export const LANDING = {
  navbarLogo: "navbar-logo",
  navbarApplyBtn: "navbar-apply-btn",

  // Le CTA aprono il form Typeform in popup (vedi landing/TypeformButton.js).
  ctaApplyHero: "cta-apply-hero",
  ctaApplyForm: "cta-apply-form",

  applicationCtaSection: "application-cta-section",

  // La community è un link esterno (canale Instagram), vedi landing/CommunityButton.js.
  communitySection: "community-section",
  ctaJoinCommunity: "cta-join-community",
  navbarCommunityLink: "navbar-community-link",

  // Le candidature si consultano su Typeform: /admin è solo un redirect.
  adminRedirectContainer: "admin-redirect-container",
  adminResultsLink: "admin-results-link",

  faqTrigger: "faq-trigger"
};
